import { render, staticRenderFns } from "./ApproveFolder.vue?vue&type=template&id=62c86330&scoped=true&"
import script from "./ApproveFolder.vue?vue&type=script&lang=js&"
export * from "./ApproveFolder.vue?vue&type=script&lang=js&"
import style0 from "./ApproveFolder.vue?vue&type=style&index=0&id=62c86330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c86330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c86330')) {
      api.createRecord('62c86330', component.options)
    } else {
      api.reload('62c86330', component.options)
    }
    module.hot.accept("./ApproveFolder.vue?vue&type=template&id=62c86330&scoped=true&", function () {
      api.rerender('62c86330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/documents/ApproveFolder.vue"
export default component.exports